import React, {Component} from 'react';
import * as Pixi from 'pixi.js';
import {GlowFilter} from 'pixi-filters';
import {motion} from "framer-motion";
import {Link} from "react-router-dom";
import {Container, Row, Col} from "react-bootstrap";

import "../CSS/GamePageStyle.css";

const HUD_PADDING = 20;
const BULLET_SPEED = 5;
const MAX_BULLETS = 5;

class GamePageComponent extends Component {

    app;
    gameCanvas;
    gameWon = false;
    gameStartTime = 0;
    gameTicker = null;
    hudContainer = null;
    hudText = null;
    winContainer = null;
    playGameText = null;
    shootingEnabled = false;
    bulletPulseTime = 0;
    onShoot = null;

    constructor(props) {
        super(props);

        const style = new Pixi.TextStyle({
            fontFamily: 'Courier New',
            fontSize: 36,
            fontStyle: 'normal',
            fill: "#ffffff",
            stroke: "black",
            fontWeight: 'normal',
            align: "center",
            strokeThickness: 5,
            wordWrap: true,
            wordWrapWidth: window.innerWidth * (0.75),
        });

        this.winTimeStyle = new Pixi.TextStyle({
            fontFamily: 'Courier New',
            fontSize: 28,
            fill: "#E8F4FF",
            stroke: "#00B4D8",
            strokeThickness: 4,
            align: "center",
        });

        this.state = {
            height: window.innerHeight,
            width: window.innerWidth,
            bullets: [],
            asteriods: [],
            ship: null,
            style: style,
        };

        this.generateAsteriods = this.generateAsteriods.bind(this);
        this.generateStars = this.generateStars.bind(this);
        this.generateShip = this.generateShip.bind(this);
        this.generateBullet = this.generateBullet.bind(this);
        this.addTicker = this.addTicker.bind(this);
        this.startGame = this.startGame.bind(this);
        this.resetForRestart = this.resetForRestart.bind(this);
    }

    getAimAngle(shipX, shipY, mouseX, mouseY) {
        return Math.atan2(mouseY - shipY, mouseX - shipX);
    }

    bringHudToFront() {
        if (this.hudContainer && this.hudContainer.parent) {
            this.app.stage.removeChild(this.hudContainer);
            this.app.stage.addChild(this.hudContainer);
        }
    }

    formatElapsed(ms) {
        const totalSeconds = ms / 1000;
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        if (minutes > 0) {
            return `${minutes}:${seconds.toFixed(1).padStart(4, '0')}s`;
        }
        return `${seconds.toFixed(1)}s`;
    }

    createHud(initialCount) {
        if (this.hudContainer) {
            this.hudContainer.destroy({children: true});
        }
        const hudLabelStyle = new Pixi.TextStyle({
            fontFamily: 'Courier New',
            fontSize: 28,
            fontStyle: 'normal',
            fill: "#ffffff",
            stroke: "black",
            fontWeight: 'normal',
            align: "right",
            strokeThickness: 5,
        });
        this.hudContainer = new Pixi.Container();
        this.hudText = new Pixi.Text(`Targets Left: ${initialCount}`, hudLabelStyle);
        this.hudText.anchor.set(1, 1);
        this.hudText.x = this.app.screen.width - HUD_PADDING;
        // Canvas is full-window but visible game area is ~90vh; keep HUD in view
        this.hudText.y = this.app.screen.height * 0.88;
        this.hudContainer.addChild(this.hudText);
        this.app.stage.addChild(this.hudContainer);
        this.bringHudToFront();
    }

    updateHudCount(count) {
        if (this.hudText) {
            this.hudText.text = `Targets Left: ${count}`;
            this.bringHudToFront();
        }
    }

    generateAsteriods() {
        const input = "Hi, I'm Athi Dharma! > Senior Software Engineer \n" +
            "> Data Engineering \n" +
            "> Game Development Enthusiast \n" +
            "> Imperial Computing Graduate (MEng AI/ML)";
        const textArray = input.split(/[ ,]+/);
        const style = new Pixi.TextStyle({
            fontFamily: 'Courier New',
            fontSize: 21,
            fontStyle: 'normal',
            fill: "#A59692",
            fontWeight: 'normal',
            align: "center",
        });

        const greyGlow = new GlowFilter({
            distance: 12,
            outerStrength: 1.8,
            innerStrength: 0.4,
            color: 0x888888,
            quality: 0.5,
        });

        const app = this.app;
        const asteroidArray = textArray.map((letter) => {
            const text = new Pixi.Text(letter.toString(), style);
            text.filters = [greyGlow];

            const container = new Pixi.Container();
            container.addChild(text);

            container.x = Math.floor(Math.random() * window.innerWidth);
            container.y = Math.floor(Math.random() * window.innerHeight);
            container.direction = Math.random() * Math.PI * 2;
            container.turningSpeed = Math.random() - 0.8;
            container.speed = 2 + Math.random() * 2;

            app.stage.addChild(container);
            return container;
        });

        this.setState({asteriods: asteroidArray});
        return asteroidArray.length;
    }

    generateStars() {
        const starAmount = 200;

        const starBoundsPadding = 10;
        const starBounds = new Pixi.Rectangle(-starBoundsPadding,
            -starBoundsPadding,
            this.app.screen.width + starBoundsPadding * 2,
            this.app.screen.height + starBoundsPadding * 2);

        const starColours = [0x98FB98, 0x87CEFA, 0xFFFACD, 0xFFFF00, 0xFFA500, 0xFF8C00, 0xFF4500];

        const vecShader = `
            attribute vec2 aVertexPosition;
            attribute vec2 aTextureCoord;

            uniform mat3 projectionMatrix;

            varying vec2 vTextureCoord;
            void main()
            {            
                gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
                vTextureCoord = aTextureCoord;
            }
         `;
        const fragShader = `
            uniform sampler2D uSampler;
            uniform float brightness;
            uniform float time;
            uniform vec2 resolution;
            uniform vec2 glowPosition;
            uniform vec3 glowColor;
            uniform vec2 mouse;
      
            void main()
            {
                float maxdist = length(resolution);
                float distance = (maxdist - distance(glowPosition, gl_FragCoord.xy)) / maxdist;
                float intensity = pow(distance, brightness);
                vec2 pixel = gl_FragCoord.xy / resolution.xy;
                vec4 color = texture2D(uSampler, pixel);
                vec3 glow = glowColor * intensity;
                gl_FragColor = vec4(sin(time),mouse.x/resolution.x,mouse.y/resolution.y,1.0);
            }
        `;

        const uniforms = {
            brightness: {type: "f", value: 10},
            glowPosition: {type: "vec2", value: {x: 20, y: 480}},
            resolution: {type: "vec2", value: [window.innerWidth, window.innerHeight]},
            glowColor: {type: "vec3", value: [0, 0, 1]},
            mouse: {type: 'v2', value: {x: 0, y: 0}},
            time: {type: "f", value: 0},
        };

        const simpleShader = new Pixi.Filter(vecShader, fragShader, uniforms);

        const glowFilter = new Pixi.Sprite(Pixi.Texture.EMPTY);
        glowFilter.width = window.innerWidth;
        glowFilter.height = window.innerHeight;
        glowFilter.filters = [simpleShader];
        this.app.stage.addChild(glowFilter);

        const starArray = [];
        for (let i = 0; i < starAmount; i++) {
            const starDot = new Pixi.Graphics();
            const radius = (Math.random() * 2) + 1;
            const colourRnd = Math.floor(Math.random() * 7);
            const colour = starColours[colourRnd];
            starDot.beginFill(colour);
            starDot.drawCircle(0, 0, radius);
            starDot.cacheAsBitmap = true;
            starDot.x = Math.floor(Math.random() * window.innerWidth);
            starDot.y = Math.floor(Math.random() * window.innerHeight);
            if (i % 10 === 0) {
                starDot.velocityX = (Math.random() * 2) - 1;
                starDot.velocityY = (Math.random() * 2) - 1;
            } else {
                starDot.velocityX = 0;
                starDot.velocityY = 0;
            }

            this.app.stage.addChild(starDot);
            starArray.push(starDot);
        }

        this.app.ticker.add(() => {
            starArray.forEach((star) => {
                if (star.x < starBounds.x) {
                    star.x += starBounds.width;
                } else if (star.x > starBounds.x + starBounds.width) {
                    star.x -= starBounds.width;
                }

                if (star.y < starBounds.y) {
                    star.y += starBounds.height;
                } else if (star.y > starBounds.y + starBounds.height) {
                    star.y -= starBounds.height;
                }
                star.x += star.velocityX / 2;
                star.y += star.velocityY / 2;
            });
        });

        this.setState({stars: starArray});
    }

    generateShip() {
        const ship = new Pixi.Graphics();

        const centreX = window.innerWidth / 2;
        const centreY = window.innerHeight / 2;
        const shipWidth = 20;
        const shipHeight = 30;
        ship.beginFill(0x000000);
        ship.lineStyle(1, 0xFFFFFF, 1);
        ship.moveTo(centreX, centreY);
        ship.lineTo(centreX + shipWidth, centreY + 1.5 * shipHeight);
        ship.lineTo(centreX, centreY + shipHeight);
        ship.lineTo(centreX - shipWidth, centreY + 1.5 * shipHeight);
        ship.lineTo(centreX, centreY);
        ship.closePath();
        ship.endFill();
        ship.pivot.x = centreX;
        ship.pivot.y = (centreY + shipHeight);
        ship.x = centreX;
        ship.y = centreY;

        ship.beginHole();
        ship.drawCircle(centreX, (centreY + shipHeight), 5);
        ship.endHole();

        this.setState({ship: ship});
        this.app.stage.addChild(ship);
    }

    createLaserBullet(startX, startY, aimAngle) {
        const bullet = new Pixi.Container();

        const laser = new Pixi.Graphics();
        laser.lineStyle(2, 0x00E5FF, 1);
        laser.beginFill(0xFFFFFF, 1);
        laser.drawRoundedRect(-2, -12, 4, 24);
        laser.endFill();
        laser.beginFill(0x7DF9FF, 0.5);
        laser.drawEllipse(0, -14, 3, 5);
        laser.endFill();

        bullet.addChild(laser);
        bullet.filters = [
            new GlowFilter({
                distance: 14,
                outerStrength: 2.5,
                innerStrength: 0.8,
                color: 0x00E5FF,
                quality: 0.5,
            }),
        ];

        bullet.x = startX;
        bullet.y = startY;
        bullet.aimAngle = aimAngle;
        bullet.rotation = aimAngle + Math.PI / 2;
        bullet.pulsePhase = Math.random() * Math.PI * 2;

        return bullet;
    }

    generateBullet() {
        const bulletArray = this.state.bullets;
        if (bulletArray.length >= MAX_BULLETS || !this.state.ship) {
            return;
        }

        const ship = this.state.ship;
        const mouseX = this.app.renderer.plugins.interaction.eventData.data.global.x;
        const mouseY = this.app.renderer.plugins.interaction.eventData.data.global.y;
        const aimAngle = this.getAimAngle(ship.position.x, ship.position.y, mouseX, mouseY);
        const startPositionX = ship.position.x + Math.cos(aimAngle) * 20;
        const startPositionY = ship.position.y + Math.sin(aimAngle) * 20;

        const bullet = this.createLaserBullet(startPositionX, startPositionY, aimAngle);
        this.app.stage.addChild(bullet);

        bulletArray.push(bullet);
        this.setState({bullets: bulletArray});
    }

    showWinScreen(elapsedMs) {
        if (this.gameWon) {
            return;
        }
        this.gameWon = true;
        this.shootingEnabled = false;

        if (this.gameTicker) {
            this.app.ticker.remove(this.gameTicker);
            this.gameTicker = null;
        }

        if (this.hudContainer) {
            this.hudContainer.destroy({children: true});
            this.hudContainer = null;
            this.hudText = null;
        }

        const ship = this.state.ship;
        if (ship) {
            ship.visible = false;
        }

        this.state.bullets.forEach((b) => b.destroy({children: true}));
        this.setState({bullets: []});

        this.winContainer = new Pixi.Container();

        const winText = new Pixi.Text("You won!", this.state.style);
        const timeText = new Pixi.Text(`Time: ${this.formatElapsed(elapsedMs)}`, this.winTimeStyle);
        const playAgainText = new Pixi.Text("Play Again", this.state.style);

        winText.anchor.set(0.5, 0);
        timeText.anchor.set(0.5, 0);

        const centerX = window.innerWidth / 2;
        const blockHeight = winText.height + 50 + timeText.height + 60 + playAgainText.height;
        let y = window.innerHeight / 2 - blockHeight / 2;

        winText.x = centerX;
        winText.y = y;
        y += winText.height + 50;

        timeText.x = centerX;
        timeText.y = y;
        y += timeText.height + 60;

        playAgainText.x = window.innerWidth / 2 - playAgainText.width / 2;
        playAgainText.y = y;
        playAgainText.interactive = true;
        playAgainText.buttonMode = true;

        this.winContainer.addChild(winText);
        this.winContainer.addChild(timeText);
        this.winContainer.addChild(playAgainText);
        this.app.stage.addChild(this.winContainer);

        playAgainText.on('pointerdown', () => {
            this.resetForRestart();
            this.startGame();
        });
    }

    resetForRestart() {
        if (this.winContainer) {
            this.winContainer.destroy({children: true});
            this.winContainer = null;
        }

        if (this.hudContainer) {
            this.hudContainer.destroy({children: true});
            this.hudContainer = null;
            this.hudText = null;
        }

        if (this.gameTicker) {
            this.app.ticker.remove(this.gameTicker);
            this.gameTicker = null;
        }

        if (this.onShoot) {
            this.app.renderer.plugins.interaction.off('pointerdown', this.onShoot);
        }

        this.state.bullets.forEach((b) => b.destroy({children: true}));
        this.state.asteriods.forEach((a) => a.destroy({children: true}));

        if (this.state.ship) {
            this.state.ship.destroy();
        }

        this.gameWon = false;
        this.shootingEnabled = false;
        this.setState({bullets: [], asteriods: [], ship: null});
    }

    startGame() {
        this.gameStartTime = Date.now();
        this.gameWon = false;
        this.shootingEnabled = true;
        this.bulletPulseTime = 0;

        const targetCount = this.generateAsteriods();
        this.generateShip();
        this.createHud(targetCount);
        this.bringHudToFront();

        if (this.onShoot) {
            this.app.renderer.plugins.interaction.off('pointerdown', this.onShoot);
        }
        this.onShoot = () => {
            if (this.shootingEnabled) {
                this.generateBullet();
            }
        };
        this.app.renderer.plugins.interaction.on('pointerdown', this.onShoot);

        this.addTicker();
    }

    addTicker() {
        if (this.gameTicker) {
            this.app.ticker.remove(this.gameTicker);
        }

        this.gameTicker = (delta) => {
            if (this.gameWon) {
                return;
            }

            const ship = this.state.ship;
            if (!ship) {
                return;
            }

            this.bulletPulseTime += 0.15 * delta;

            const asteriodBoundsPadding = 10;
            const asteriodBounds = new Pixi.Rectangle(-asteriodBoundsPadding,
                -asteriodBoundsPadding,
                this.app.screen.width + asteriodBoundsPadding * 2,
                this.app.screen.height + asteriodBoundsPadding * 2);

            const mousepositionX = this.app.renderer.plugins.interaction.eventData.data.global.x;
            const mousepositionY = this.app.renderer.plugins.interaction.eventData.data.global.y;
            const posX = ship.position.x;
            const posY = ship.position.y;

            const dist_Y = mousepositionY - posY;
            const dist_X = mousepositionX - posX;
            ship.rotation = Math.atan2(dist_Y, dist_X) + 90 * Math.PI / 180;

            let asteriods = [...this.state.asteriods];
            let bullets = [...this.state.bullets];

            if (asteriods.length === 0) {
                const elapsedMs = Date.now() - this.gameStartTime;
                this.showWinScreen(elapsedMs);
                return;
            }

            for (let i = 0; i < asteriods.length; i++) {
                const asteriod = asteriods[i];
                asteriod.direction += asteriod.turningSpeed * 0.01;
                asteriod.x += Math.sin(asteriod.direction) * asteriod.speed;
                asteriod.y += Math.cos(asteriod.direction) * asteriod.speed;
                asteriod.rotation = -asteriod.direction - Math.PI / 2;

                if (asteriod.x < asteriodBounds.x) {
                    asteriod.x += asteriodBounds.width;
                } else if (asteriod.x > asteriodBounds.x + asteriodBounds.width) {
                    asteriod.x -= asteriodBounds.width;
                }

                if (asteriod.y < asteriodBounds.y) {
                    asteriod.y += asteriodBounds.height;
                } else if (asteriod.y > asteriodBounds.y + asteriodBounds.height) {
                    asteriod.y -= asteriodBounds.height;
                }
            }

            const removeAsteroids = [...asteriods];
            const survivingBullets = [];
            let asteroidsChanged = false;

            for (let b = 0; b < bullets.length; b++) {
                const bullet = bullets[b];
                const aimAngle = bullet.aimAngle;
                bullet.position.x += Math.cos(aimAngle) * BULLET_SPEED;
                bullet.position.y += Math.sin(aimAngle) * BULLET_SPEED;

                const pulse = 1 + 0.15 * Math.sin(this.bulletPulseTime + bullet.pulsePhase);
                bullet.scale.set(pulse);

                for (let i = removeAsteroids.length - 1; i >= 0; i--) {
                    const bounds = removeAsteroids[i].getBounds();
                    const bx = bullet.position.x;
                    const by = bullet.position.y;

                    if (bounds.x + bounds.width >= bx && bounds.x <= bx &&
                        bounds.y + bounds.height >= by && bounds.y <= by) {
                        removeAsteroids[i].destroy({children: true});
                        removeAsteroids.splice(i, 1);
                        asteroidsChanged = true;
                    }
                }

                if (bullet.position.x < 0 || bullet.position.y < 0 ||
                    bullet.position.x > window.innerWidth || bullet.position.y > window.innerHeight) {
                    bullet.destroy({children: true});
                } else {
                    survivingBullets.push(bullet);
                }
            }

            bullets = survivingBullets;
            asteriods = removeAsteroids;

            if (asteroidsChanged) {
                this.updateHudCount(asteriods.length);
            }

            this.setState({bullets, asteriods}, () => {
                if (asteriods.length === 0 && !this.gameWon) {
                    const elapsedMs = Date.now() - this.gameStartTime;
                    this.showWinScreen(elapsedMs);
                }
            });
        };

        this.app.ticker.add(this.gameTicker);
    }

    componentDidMount() {
        this.app = new Pixi.Application({
            autoResize: true,
            width: window.innerWidth,
            height: window.innerHeight,
            resizeTo: window,
            resolution: devicePixelRatio,
            antialias: true
        });

        this.gameCanvas.appendChild(this.app.view);
        this.app.start();
        this.app.interactive = true;

        this.generateStars();

        this.playGameText = new Pixi.Text("Play Game", this.state.style);
        this.playGameText.x = window.innerWidth / 2 - this.playGameText.width / 2;
        this.playGameText.y = window.innerHeight / 2 + this.playGameText.height / 2;
        this.playGameText.interactive = true;
        this.playGameText.buttonMode = true;
        this.app.stage.addChild(this.playGameText);

        this.playGameText.on('pointerdown', () => {
            this.playGameText.interactive = false;
            this.playGameText.visible = false;
            this.startGame();
        });
    }

    componentWillUnmount() {
        if (this.gameTicker) {
            this.app.ticker.remove(this.gameTicker);
        }

        if (this.onShoot) {
            this.app.renderer.plugins.interaction.off('pointerdown', this.onShoot);
        }

        if (this.winContainer) {
            this.winContainer.destroy({children: true});
        }

        if (this.hudContainer) {
            this.hudContainer.destroy({children: true});
        }

        this.state.bullets.forEach((b) => b.destroy({children: true}));
        this.state.asteriods.forEach((a) => a.destroy({children: true}));

        if (this.state.ship) {
            this.state.ship.destroy();
        }

        this.setState({bullets: [], asteriods: []});
        this.app.stop();
    }

    render() {
        const component = this;

        const pageVariants = {
            initial: {
                opacity: 0,
                y: "-100vh",
                scale: 0.8
            },
            in: {
                opacity: 1,
                y: 0,
                scale: 1
            },
            out: {
                opacity: 0,
                y: "100vh",
                scale: 1.2
            }
        };

        const pageTransition = {
            duration: 0.5,
            transition: "linear"
        };

        return (
            <motion.div
                initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
            >
                <Container className="game-container" fluid>
                    <Row className="landing-row">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="landing-col">
                            <Link to="/" className="arrow-up" />
                            <div className="div-up"> Home </div>
                        </Col>
                    </Row>
                    <Row className="game-row">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="game-col">
                            <div ref={(thisDiv) => {
                                component.gameCanvas = thisDiv
                            }}/>
                        </Col>
                    </Row>
                </Container>
            </motion.div>
        );
    }
}

export default GamePageComponent;
